(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[0,1435,53,75],[0,1215,270,42],[0,1127,409,42],[0,1347,153,42],[0,1083,534,42],[0,1303,225,42],[0,1259,259,42],[0,1391,137,42],[0,1171,273,42],[0,0,519,1081]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_230 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_229 = function() {
	this.initialize(img.CachedBmp_229);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2716,33);


(lib.CachedBmp_228 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_227 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_226 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_225 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_224 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_223 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_222 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_221 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.Group = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,500);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1000), null);


(lib.size_1920x80 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x80, new cjs.Rectangle(0,0,1920,80), null);


(lib.setaVideo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4.3,-6.3).lineTo(3.5,-1.4).curveTo(3.9,-1.1,4,-0.8).curveTo(4.4,-0.2,4.2,0.4).curveTo(4.1,1,3.5,1.3).lineTo(-4.3,6.3).closePath().moveTo(-3.2,4.4).lineTo(2.9,0.4).lineTo(3.1,0.3).curveTo(3.5,-0.2,2.9,-0.4).lineTo(-3.2,-4.3).closePath();
	this.shape.setTransform(4.2614,6.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.setaVideo, new cjs.Rectangle(0,0,8.5,12.6), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#CAAF6F").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-30).lineTo(-550,-30).moveTo(550,30).lineTo(-250,30);
	this.shape.setTransform(550,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#CFDBB3").beginStroke().moveTo(34.3,21.2).curveTo(33.5,20.7,33.1,20).curveTo(32.7,19.3,32.7,18.4).curveTo(32.7,17.6,33.1,16.9).curveTo(33.5,16.1,34.3,15.7).curveTo(35,15.3,35.8,15.3).curveTo(36.8,15.3,37.5,15.7).curveTo(38.2,16.1,38.6,16.9).curveTo(39.1,17.6,39.1,18.4).curveTo(39.1,19.3,38.6,20).curveTo(38.2,20.7,37.5,21.2).curveTo(36.7,21.6,35.8,21.6).curveTo(35,21.6,34.3,21.2).closePath().moveTo(34.7,16.5).curveTo(34.2,16.8,33.9,17.3).curveTo(33.7,17.8,33.7,18.4).curveTo(33.7,19.1,33.9,19.6).curveTo(34.2,20.1,34.7,20.4).curveTo(35.3,20.7,35.8,20.7).curveTo(36.5,20.7,37,20.4).curveTo(37.5,20.1,37.7,19.6).curveTo(38.1,19,38.1,18.4).curveTo(38.1,17.8,37.7,17.3).curveTo(37.5,16.8,37,16.5).curveTo(36.5,16.2,35.8,16.2).curveTo(35.2,16.2,34.7,16.5).closePath().moveTo(-14.9,21.2).curveTo(-15.6,20.7,-16,20).curveTo(-16.4,19.3,-16.4,18.4).curveTo(-16.4,17.6,-16,16.9).curveTo(-15.6,16.1,-14.9,15.7).curveTo(-14.1,15.3,-13.2,15.3).curveTo(-12.6,15.3,-12,15.5).curveTo(-11.4,15.8,-11.1,16.2).curveTo(-10.6,16.5,-10.4,17.1).lineTo(-11.3,17.4).curveTo(-11.6,16.9,-12.1,16.5).curveTo(-12.5,16.2,-13.2,16.2).curveTo(-13.8,16.2,-14.3,16.5).curveTo(-14.9,16.8,-15.1,17.3).curveTo(-15.4,17.8,-15.4,18.4).curveTo(-15.4,19.1,-15.1,19.6).curveTo(-14.9,20.1,-14.3,20.4).curveTo(-13.8,20.7,-13.2,20.7).curveTo(-12.6,20.7,-12.1,20.3).curveTo(-11.6,20,-11.3,19.5).lineTo(-10.4,19.8).curveTo(-10.6,20.3,-11.1,20.7).curveTo(-11.4,21.1,-12,21.4).curveTo(-12.6,21.6,-13.2,21.6).curveTo(-14.1,21.6,-14.9,21.2).closePath().moveTo(-55.4,21.2).curveTo(-56.1,20.7,-56.5,20).curveTo(-56.9,19.3,-57,18.4).curveTo(-56.9,17.6,-56.5,16.9).curveTo(-56.1,16.1,-55.4,15.7).curveTo(-54.6,15.3,-53.7,15.3).curveTo(-53.1,15.3,-52.6,15.5).curveTo(-51.9,15.8,-51.6,16.2).curveTo(-51.1,16.6,-50.9,17.1).lineTo(-51.8,17.4).curveTo(-52.1,16.9,-52.6,16.5).curveTo(-53,16.2,-53.7,16.2).curveTo(-54.4,16.2,-54.8,16.5).curveTo(-55.4,16.8,-55.6,17.3).curveTo(-55.9,17.8,-55.9,18.4).curveTo(-55.9,19.1,-55.6,19.6).curveTo(-55.4,20.1,-54.8,20.4).curveTo(-54.3,20.7,-53.7,20.7).curveTo(-53.1,20.7,-52.6,20.3).curveTo(-52.1,20,-51.8,19.5).lineTo(-50.9,19.8).curveTo(-51.1,20.2,-51.6,20.7).curveTo(-51.9,21.1,-52.6,21.4).curveTo(-53,21.6,-53.7,21.6).curveTo(-54.6,21.6,-55.4,21.2).closePath().moveTo(53,21.5).lineTo(53,15.4).lineTo(57,15.4).lineTo(57,16.2).lineTo(54,16.2).lineTo(54,18).lineTo(56.9,18).lineTo(56.9,18.9).lineTo(54,18.9).lineTo(54,20.6).lineTo(57,20.6).lineTo(57,21.5).closePath().moveTo(48.7,21.5).lineTo(48.7,16.2).lineTo(46.6,16.2).lineTo(46.6,15.4).lineTo(51.6,15.4).lineTo(51.6,16.2).lineTo(49.6,16.2).lineTo(49.6,21.5).closePath().moveTo(44.3,21.5).lineTo(42.7,19.1).lineTo(41.7,19.1).lineTo(41.7,21.5).lineTo(40.8,21.5).lineTo(40.8,15.4).lineTo(43.3,15.4).curveTo(43.9,15.4,44.4,15.6).curveTo(44.8,15.8,45.1,16.3).curveTo(45.4,16.7,45.4,17.3).curveTo(45.4,17.8,45.1,18.2).curveTo(44.8,18.6,44.4,18.8).lineTo(43.8,19).lineTo(45.5,21.5).closePath().moveTo(41.7,18.2).lineTo(43.3,18.2).curveTo(43.6,18.2,43.8,18.1).lineTo(44.2,17.7).lineTo(44.3,17.3).lineTo(44.2,16.7).lineTo(43.8,16.4).curveTo(43.6,16.2,43.3,16.2).lineTo(41.7,16.2).closePath().moveTo(30,21.5).lineTo(26.6,17).lineTo(26.6,21.5).lineTo(25.7,21.5).lineTo(25.7,15.4).lineTo(26.6,15.4).lineTo(30,19.9).lineTo(30,15.4).lineTo(31,15.4).lineTo(31,21.5).closePath().moveTo(19.3,21.5).lineTo(17.7,19.1).lineTo(16.7,19.1).lineTo(16.7,21.5).lineTo(15.8,21.5).lineTo(15.8,15.4).lineTo(18.4,15.4).curveTo(19,15.4,19.4,15.6).curveTo(19.8,15.9,20.1,16.3).curveTo(20.4,16.7,20.4,17.3).curveTo(20.4,17.7,20.1,18.2).curveTo(19.8,18.6,19.4,18.8).lineTo(18.9,19).lineTo(20.5,21.5).closePath().moveTo(16.7,18.2).lineTo(18.4,18.2).curveTo(18.7,18.2,18.9,18.1).lineTo(19.3,17.7).lineTo(19.3,17.3).lineTo(19.3,16.7).lineTo(18.9,16.4).lineTo(18.4,16.2).lineTo(16.7,16.2).closePath().moveTo(10.2,21.5).lineTo(10.2,15.4).lineTo(14,15.4).lineTo(14,16.2).lineTo(11.1,16.2).lineTo(11.1,18).lineTo(14,18).lineTo(14,18.9).lineTo(11.1,18.9).lineTo(11.1,20.6).lineTo(14,20.6).lineTo(14,21.5).closePath().moveTo(5.8,21.5).lineTo(5.8,16.2).lineTo(3.8,16.2).lineTo(3.8,15.4).lineTo(8.6,15.4).lineTo(8.6,16.2).lineTo(6.7,16.2).lineTo(6.7,21.5).closePath().moveTo(1.3,21.5).lineTo(-2.1,17).lineTo(-2.1,21.5).lineTo(-3,21.5).lineTo(-3,15.4).lineTo(-2.1,15.4).lineTo(1.3,19.9).lineTo(1.3,15.4).lineTo(2.3,15.4).lineTo(2.3,21.5).closePath().moveTo(-8.6,21.5).lineTo(-8.6,15.4).lineTo(-4.8,15.4).lineTo(-4.8,16.2).lineTo(-7.7,16.2).lineTo(-7.7,18).lineTo(-4.9,18).lineTo(-4.9,18.9).lineTo(-7.7,18.9).lineTo(-7.7,20.6).lineTo(-4.8,20.6).lineTo(-4.8,21.5).closePath().moveTo(-25.4,21.5).lineTo(-25.4,15.4).lineTo(-21.5,15.4).lineTo(-21.5,16.2).lineTo(-24.5,16.2).lineTo(-24.5,18).lineTo(-21.6,18).lineTo(-21.6,18.9).lineTo(-24.5,18.9).lineTo(-24.5,20.6).lineTo(-21.5,20.6).lineTo(-21.5,21.5).closePath().moveTo(-32.5,21.5).lineTo(-32.5,15.4).lineTo(-30.2,15.4).curveTo(-29.4,15.4,-28.6,15.8).curveTo(-27.9,16.1,-27.5,16.9).curveTo(-27.2,17.6,-27.2,18.4).curveTo(-27.2,19.3,-27.5,20).curveTo(-27.9,20.6,-28.6,21.1).curveTo(-29.4,21.5,-30.2,21.5).closePath().moveTo(-31.6,20.6).lineTo(-30.3,20.6).curveTo(-29.6,20.6,-29.2,20.3).curveTo(-28.7,20.1,-28.4,19.5).curveTo(-28.1,19.1,-28.1,18.4).curveTo(-28.1,17.8,-28.4,17.3).curveTo(-28.7,16.8,-29.2,16.5).curveTo(-29.7,16.2,-30.3,16.2).lineTo(-31.6,16.2).closePath().moveTo(-35,21.5).lineTo(-35.6,20).lineTo(-38.5,20).lineTo(-39.2,21.5).lineTo(-40.1,21.5).lineTo(-37.6,15.4).lineTo(-36.5,15.4).lineTo(-33.9,21.5).closePath().moveTo(-38.2,19.1).lineTo(-35.9,19.1).lineTo(-37.1,16.5).closePath().moveTo(-46.3,21.5).lineTo(-46.3,15.4).lineTo(-44,15.4).curveTo(-43.2,15.4,-42.5,15.8).curveTo(-41.8,16.1,-41.3,16.9).curveTo(-40.9,17.6,-40.9,18.4).curveTo(-40.9,19.3,-41.3,20).curveTo(-41.8,20.6,-42.5,21.1).curveTo(-43.2,21.5,-44,21.5).closePath().moveTo(-45.4,20.6).lineTo(-44.1,20.6).curveTo(-43.5,20.6,-43,20.3).curveTo(-42.5,20.1,-42.2,19.5).curveTo(-41.9,19.1,-41.9,18.4).curveTo(-41.9,17.8,-42.2,17.3).curveTo(-42.5,16.8,-43,16.5).curveTo(-43.5,16.2,-44.1,16.2).lineTo(-45.4,16.2).closePath().moveTo(-49.2,21.5).lineTo(-49.2,15.4).lineTo(-48.2,15.4).lineTo(-48.2,21.5).closePath().moveTo(-18.3,2.7).lineTo(-17.8,2.7).lineTo(-17,2.6).lineTo(-16.9,7.8).lineTo(-18.2,7.9).closePath().moveTo(-22,7.2).lineTo(-20.7,2.1).lineTo(-20.7,2).lineTo(-20.1,-0.5).lineTo(-18.8,-0.2).lineTo(-20.8,7.6).lineTo(-22,7.2).closePath().moveTo(-16.6,-0.2).curveTo(-16,-0.3,-15.4,-0.5).lineTo(-13.2,7.1).lineTo(-14.3,7.5).closePath().moveTo(-25,6).lineTo(-23.7,0).lineTo(-23.9,0.3).lineTo(-27.6,4.1).lineTo(-28.4,3.3).lineTo(-22.9,-2.5).lineTo(-22.1,-1.6).lineTo(-23.9,6.5).lineTo(-25,6).closePath().moveTo(-12.7,1.1).lineTo(-12.8,1.1).lineTo(-13.4,-1.7).lineTo(-13.4,-1.7).lineTo(-13.4,-1.8).lineTo(-12.5,-2.6).lineTo(-6.8,2.9).lineTo(-7.7,3.8).lineTo(-11.5,0.1).lineTo(-11.5,0.1).lineTo(-11.8,-0.2).lineTo(-10.4,5.8).lineTo(-11.4,6.4).closePath().moveTo(-30.8,0.2).lineTo(-26.3,-2.5).lineTo(-25.7,-1.4).lineTo(-30.2,1.2).lineTo(-30.8,0.2).closePath().moveTo(-9.8,-1.7).lineTo(-9.3,-2.8).lineTo(-4.7,-0.3).lineTo(-5.2,0.8).closePath().moveTo(-32.1,-3.4).lineTo(-26.7,-5).lineTo(-32.5,-6.4).lineTo(-32.5,-7.7).lineTo(-24.5,-5.6).lineTo(-24.5,-5.6).lineTo(-24.1,-4.4).lineTo(-31.8,-2.2).lineTo(-32.1,-3.4).closePath().moveTo(-8.8,-4).lineTo(-8.9,-4).lineTo(-11.4,-4.7).curveTo(-11.2,-5.1,-11.2,-5.8).lineTo(-11.1,-5.9).lineTo(-8.5,-6.6).lineTo(-8.4,-6.7).lineTo(-3.2,-8.3).lineTo(-3.1,-7).lineTo(-8.6,-5.4).lineTo(-8.6,-5.3).lineTo(-8.9,-5.3).lineTo(-8.6,-5.2).lineTo(-8.6,-5.1).lineTo(-3.4,-3.9).lineTo(-3.7,-2.7).closePath().moveTo(-27.1,-8.5).lineTo(-27.1,-8.5).lineTo(-32.2,-9.9).lineTo(-31.9,-11).lineTo(-26.8,-9.7).lineTo(-26.7,-9.7).lineTo(-24.2,-9.1).lineTo(-24.5,-7.9).closePath().moveTo(-11.5,-9.3).lineTo(-3.9,-11.5).lineTo(-3.5,-10.3).lineTo(-11.2,-8.1).curveTo(-11.3,-8.8,-11.5,-9.3).closePath().moveTo(-31,-13.5).lineTo(-30.7,-14).lineTo(-30.7,-14).lineTo(-30.5,-14.3).lineTo(-30.5,-14.3).lineTo(-30.4,-14.5).lineTo(-25.8,-12).lineTo(-26.4,-11).closePath().moveTo(-28.8,-16.7).lineTo(-28,-17.5).lineTo(-23.7,-13.4).lineTo(-25.3,-19.6).lineTo(-24.1,-20.2).lineTo(-22.1,-12.1).lineTo(-22.2,-12).lineTo(-22.2,-12).curveTo(-22.7,-11.6,-23.1,-11.1).closePath().moveTo(-10,-12.2).lineTo(-5.6,-14.9).lineTo(-4.9,-13.9).lineTo(-9.4,-11.2).lineTo(-10,-12.2).closePath().moveTo(-13.6,-12.2).lineTo(-11.9,-20.3).lineTo(-11.6,-20.2).lineTo(-10.7,-19.8).lineTo(-12,-14.1).lineTo(-12,-14).lineTo(-12,-13.7).lineTo(-8,-17.8).lineTo(-7.1,-17).lineTo(-10.9,-13.2).lineTo(-10.9,-13.2).lineTo(-12.7,-11.3).curveTo(-13.1,-11.8,-13.6,-12.2).closePath().moveTo(-22.4,-20.8).lineTo(-22.1,-21).lineTo(-21.8,-21).lineTo(-21.8,-21.1).lineTo(-21.2,-21.2).lineTo(-19.1,-13.5).lineTo(-20.3,-13.2).closePath().moveTo(-16.8,-13.6).lineTo(-16.1,-16.1).lineTo(-16.1,-16.1).lineTo(-14.9,-21.3).lineTo(-14.8,-21.3).lineTo(-13.7,-21).lineTo(-14.9,-15.9).lineTo(-14.9,-15.8).lineTo(-15.6,-13.3).lineTo(-16.8,-13.6).closePath().moveTo(-18.6,-16.3).lineTo(-18.6,-21.5).lineTo(-18.2,-21.6).lineTo(-17.8,-21.6).lineTo(-17.5,-21.6).lineTo(-17.4,-16.3).closePath();
	this.shape.setTransform(125.1045,47.5822,0.9001,0.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FEF7E3").beginStroke().moveTo(58.6,22.8).curveTo(55.7,21.7,54.2,19.1).curveTo(52.6,16.2,53.5,12.7).curveTo(54.5,8.6,58.6,7.3).curveTo(61.5,6.3,67.4,6.5).lineTo(72.7,6.8).lineTo(72.7,3.8).curveTo(72.5,-0.3,70.5,-2.3).curveTo(68.5,-4.3,64.8,-4.3).curveTo(59.5,-4.3,55.4,0.6).lineTo(54.9,0.1).curveTo(57.5,-2.8,60.4,-4.4).curveTo(63.5,-6.1,67.1,-6.1).curveTo(72.1,-6.1,74.6,-3.4).curveTo(77.1,-0.8,77.1,4.1).lineTo(77.1,15.4).curveTo(77.1,18.8,77.6,20.2).curveTo(78,21.4,79.4,21.8).lineTo(79.4,22.6).lineTo(74.4,22.6).curveTo(73.5,22.6,73.1,22.1).curveTo(72.8,21.7,72.7,20.9).lineTo(72.7,15.3).curveTo(70.8,18.3,68.2,20.3).curveTo(65.6,22.3,63,22.9).curveTo(61.9,23.1,60.9,23.1).curveTo(59.7,23.1,58.6,22.8).closePath().moveTo(58.1,11.9).curveTo(57.1,14.6,58.1,17).curveTo(59.1,19.5,61.4,20.2).curveTo(62.2,20.4,63,20.5).curveTo(65.7,20.6,68.4,18.6).curveTo(70.8,16.9,72.7,13.8).lineTo(72.7,7.4).lineTo(68.5,7.2).lineTo(68.3,7.2).curveTo(59.6,7.2,58.1,11.9).closePath().moveTo(-70.4,21.8).curveTo(-73,20.7,-74.7,18.9).lineTo(-76.6,22.6).lineTo(-77.1,22.6).lineTo(-77.1,-14.6).curveTo(-77.1,-17.4,-77.7,-18.4).curveTo(-78.1,-19.2,-79.4,-19.8).lineTo(-79.4,-20.4).lineTo(-73.2,-23.1).lineTo(-72.6,-22.7).lineTo(-72.6,-2.2).curveTo(-67,-6.1,-62.2,-6.1).curveTo(-56.7,-6.1,-53.3,-2.2).curveTo(-49.8,1.7,-49.8,7.7).curveTo(-49.8,14,-53.6,18.4).curveTo(-57.7,23.1,-64.5,23.1).curveTo(-67.5,23.1,-70.4,21.8).closePath().moveTo(-72.6,-1.4).lineTo(-72.6,13).curveTo(-72.7,16.2,-69.6,19).curveTo(-66.5,22,-62.7,22).curveTo(-58.4,22,-56.2,18.9).curveTo(-53.9,16.1,-54,11).curveTo(-54,5.3,-56.4,1).curveTo(-59.4,-4.2,-64.8,-4.2).curveTo(-68.5,-4.2,-72.6,-1.4).closePath().moveTo(41.1,22.6).lineTo(41.1,21.8).curveTo(42.4,21.5,42.9,20.2).curveTo(43.3,18.9,43.3,15.4).lineTo(43.3,4.3).curveTo(43.3,-4.2,36.9,-4.2).curveTo(34.6,-4.2,32.2,-3).curveTo(30.2,-2.1,27.6,-0).curveTo(28,1.4,28,3.3).lineTo(28,15.4).curveTo(28,18.9,28.4,20.2).curveTo(28.9,21.5,30.2,21.8).lineTo(30.2,22.6).lineTo(21.3,22.6).lineTo(21.3,21.8).curveTo(22.5,21.5,23.1,20.2).curveTo(23.5,18.8,23.6,15.4).lineTo(23.6,4.3).curveTo(23.6,-4.2,17.1,-4.2).curveTo(14.9,-4.2,12.4,-3.1).curveTo(10.5,-2.1,7.9,-0.2).lineTo(7.9,15.4).curveTo(7.9,18.9,8.4,20.2).curveTo(8.9,21.5,10.2,21.8).lineTo(10.2,22.6).lineTo(1.2,22.6).lineTo(1.2,21.8).curveTo(2.6,21.5,3,20.2).curveTo(3.5,18.9,3.4,15.4).lineTo(3.4,2.4).curveTo(3.4,-0.4,3,-1.4).curveTo(2.5,-2.2,1.2,-2.8).lineTo(1.2,-3.4).lineTo(7.4,-6.2).lineTo(7.9,-5.8).lineTo(7.9,-1).curveTo(10.8,-3.2,13.5,-4.5).curveTo(16.7,-6.1,19.6,-6.1).curveTo(25.9,-6.1,27.5,-0.8).curveTo(34.1,-6.1,39.4,-6.1).curveTo(43.6,-6.1,45.6,-3.8).curveTo(47.8,-1.5,47.7,3.3).lineTo(47.7,15.4).curveTo(47.8,18.8,48.2,20.2).curveTo(48.8,21.5,50,21.8).lineTo(50,22.6).closePath().moveTo(-45.5,22.6).lineTo(-45.5,21.8).curveTo(-44.2,21.5,-43.8,20.2).curveTo(-43.3,18.9,-43.3,15.4).lineTo(-43.3,2.4).curveTo(-43.3,-0.4,-43.8,-1.4).curveTo(-44.3,-2.2,-45.5,-2.8).lineTo(-45.5,-3.4).lineTo(-39.3,-6.2).lineTo(-38.9,-5.8).lineTo(-38.9,15.4).curveTo(-38.9,18.8,-38.3,20.2).curveTo(-37.9,21.5,-36.6,21.8).lineTo(-36.6,22.6).closePath().moveTo(-43.6,-10.5).curveTo(-44.6,-11.4,-44.5,-12.7).curveTo(-44.6,-14,-43.6,-15).curveTo(-42.7,-15.9,-41.4,-15.9).curveTo(-40.1,-15.9,-39.2,-15).curveTo(-38.3,-14.1,-38.3,-12.7).curveTo(-38.3,-11.4,-39.2,-10.5).curveTo(-40.1,-9.6,-41.4,-9.6).curveTo(-42.7,-9.6,-43.6,-10.5).closePath();
	this.shape_1.setTransform(125.0145,33.8244,0.9001,0.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1},{t:this.shape}]},4).wait(1));

	// size
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-125,40).lineTo(-125,-40).lineTo(125,-40).lineTo(125,40).closePath();
	this.shape_2.setTransform(125,40);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,250,80);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.go_back = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.instance = new lib.button();
	this.instance.setTransform(20.25,40.25,0.3126,0.6252,0,0,0,0.8,0.4);
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text
	this.instance_1 = new lib.CachedBmp_230();
	this.instance_1.setTransform(8.5,21.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,40).lineTo(-20,-40).lineTo(20,-40).lineTo(20,40).closePath();
	this.shape.setTransform(20,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.go_back, new cjs.Rectangle(0,0,40,80), null);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(88,14.2);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// square
	this.instance_1 = new lib.square();
	this.instance_1.setTransform(88,14.2);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// ball
	this.instance_2 = new lib.ball();
	this.instance_2.setTransform(79.7,14.2);
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// shadow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(1,0,0,4).moveTo(589.8,-20).lineTo(749.8,-20).curveTo(759.8,-20,759.8,-10).lineTo(759.8,10).curveTo(759.8,20,749.8,20).lineTo(589.8,20).curveTo(579.8,20,579.8,10).lineTo(579.8,-10).curveTo(579.8,-20,589.8,-20).closePath().moveTo(473,-20).lineTo(558,-20).curveTo(568,-20,568,-10).lineTo(568,10).curveTo(568,20,558,20).lineTo(473,20).curveTo(463,20,463,10).lineTo(463,-10).curveTo(463,-20,473,-20).closePath().moveTo(295.2,-20).lineTo(441.2,-20).curveTo(451.2,-20,451.2,-10).lineTo(451.2,10).curveTo(451.2,20,441.2,20).lineTo(295.2,20).curveTo(285.2,20,285.2,10).lineTo(285.2,-10).curveTo(285.2,-20,295.2,-20).closePath().moveTo(130.4,-20).lineTo(263.4,-20).curveTo(273.4,-20,273.4,-10).lineTo(273.4,10).curveTo(273.4,20,263.4,20).lineTo(130.4,20).curveTo(120.4,20,120.4,10).lineTo(120.4,-10).curveTo(120.4,-20,130.4,-20).closePath().moveTo(-189.4,-20).lineTo(98.6,-20).curveTo(108.6,-20,108.6,-10).lineTo(108.6,10).curveTo(108.6,20,98.6,20).lineTo(-189.4,20).curveTo(-199.4,20,-199.4,10).lineTo(-199.4,-10).curveTo(-199.4,-20,-189.4,-20).closePath().moveTo(-447.2,-20).lineTo(-221.2,-20).curveTo(-211.2,-20,-211.2,-10).lineTo(-211.2,10).curveTo(-211.2,20,-221.2,20).lineTo(-447.2,20).curveTo(-457.2,20,-457.2,10).lineTo(-457.2,-10).curveTo(-457.2,-20,-447.2,-20).closePath().moveTo(-628,-20).lineTo(-479,-20).curveTo(-469,-20,-469,-10).lineTo(-469,10).curveTo(-469,20,-479,20).lineTo(-628,20).curveTo(-638,20,-638,10).lineTo(-638,-10).curveTo(-638,-20,-628,-20).closePath().moveTo(-749.8,-20).lineTo(-659.8,-20).curveTo(-649.8,-20,-649.8,-10).lineTo(-649.8,10).curveTo(-649.8,20,-659.8,20).lineTo(-749.8,20).curveTo(-759.8,20,-759.8,10).lineTo(-759.8,-10).curveTo(-759.8,-20,-749.8,-20).closePath();
	this.shape.setTransform(1102.05,42.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// size
	this.instance_3 = new lib.size_1920x80();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,0,1920,80), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(1).to({y:0},9).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,0);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#21372B").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,82), null);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9));

	// background
	this.instance = new lib.Group();

	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#21372B").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape},{t:this.instance}]},1).to({state:[]},2).wait(6));

	// size
	this.instance_1 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1081);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart(library_name, 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete(library_name, 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd(library_name, 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(1).to({alpha:0},9).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1000);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,frame09:9};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(10));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(397.35,90);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:550.35},0).wait(1).to({x:771.85},0).wait(1).to({x:1066.1},0).wait(1).to({x:1303.25},0).wait(1).to({x:1469.75},0).wait(1).to({x:1621.4},0).wait(1).to({x:1773.9},0).wait(1));

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-40.5,18).curveTo(-49.5,18,-49.5,9).lineTo(-49.5,-9).curveTo(-49.5,-18,-40.5,-18).lineTo(40.5,-18).curveTo(49.5,-18,49.5,-9).lineTo(49.5,9).curveTo(49.5,18,40.5,18).closePath();
	this.shape.setTransform(397.25,42.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-74.5,20).curveTo(-84.5,20,-84.5,10).lineTo(-84.5,-10).curveTo(-84.5,-20,-74.5,-20).lineTo(74.5,-20).curveTo(84.5,-20,84.5,-10).lineTo(84.5,10).curveTo(84.5,20,74.5,20).closePath();
	this.shape_1.setTransform(548.5417,42.4997,0.9,0.9);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-101.7,18).curveTo(-110.7,18,-110.7,9).lineTo(-110.7,-9).curveTo(-110.7,-18,-101.7,-18).lineTo(101.7,-18).curveTo(110.7,-18,110.7,-9).lineTo(110.7,9).curveTo(110.7,18,101.7,18).closePath();
	this.shape_2.setTransform(767.85,42.5);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-135.8,17.8).curveTo(-145.2,17.8,-145.2,8.9).lineTo(-145.2,-9).curveTo(-145.2,-17.8,-135.8,-17.9).lineTo(135.8,-17.9).curveTo(145.2,-17.8,145.2,-9).lineTo(145.2,8.9).curveTo(145.2,17.8,135.8,17.8).closePath();
	this.shape_3.setTransform(1056.65,42.55);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-60.8,15.6).curveTo(-69.9,15.6,-69.9,7.8).lineTo(-69.9,-7.8).curveTo(-69.9,-15.7,-60.8,-15.7).lineTo(60.7,-15.7).curveTo(69.9,-15.7,69.9,-7.8).lineTo(69.9,7.8).curveTo(69.9,15.6,60.7,15.6).closePath();
	this.shape_4.setTransform(1299,42.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-68.1,16.7).curveTo(-77.5,16.7,-77.5,8.4).lineTo(-77.5,-8.3).curveTo(-77.5,-16.7,-68.1,-16.7).lineTo(68.2,-16.7).curveTo(77.5,-16.7,77.5,-8.3).lineTo(77.5,8.4).curveTo(77.5,16.7,68.2,16.7).closePath();
	this.shape_5.setTransform(1470.25,42.55);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-38,15.6).curveTo(-47.1,15.6,-47,7.8).lineTo(-47,-7.8).curveTo(-47.1,-15.6,-38,-15.6).lineTo(38.1,-15.6).curveTo(47,-15.6,47,-7.8).lineTo(47,7.8).curveTo(47,15.6,38.1,15.6).closePath();
	this.shape_6.setTransform(1617.55,42.55);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.beginFill("rgba(33,55,43,0.8)").beginStroke().moveTo(-75.1,15.6).curveTo(-84.5,15.6,-84.5,7.8).lineTo(-84.5,-7.8).curveTo(-84.5,-15.7,-75.1,-15.7).lineTo(75.1,-15.7).curveTo(84.5,-15.7,84.5,-7.8).lineTo(84.5,7.8).curveTo(84.5,15.6,75.1,15.6).closePath();
	this.shape_7.setTransform(1771.85,42.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).wait(1));

	// menu_base
	this.instance = new lib.setaVideo();
	this.instance.setTransform(1580,42.5,1,1,0,0,0,4.2,6.3);
	this.instance.alpha = 0.3008;

	this.instance_1 = new lib.CachedBmp_229();
	this.instance_1.setTransform(352,34.25,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_228();
	this.instance_2.setTransform(493.85,32,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_227();
	this.instance_3.setTransform(678.8,32,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_226();
	this.instance_4.setTransform(370.9,32,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_225();
	this.instance_5.setTransform(936,32,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_224();
	this.instance_6.setTransform(1256.8,32,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_223();
	this.instance_7.setTransform(1415.95,32,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_222();
	this.instance_8.setTransform(1593.3,32,0.5,0.5);

	this.instance_9 = new lib.CachedBmp_221();
	this.instance_9.setTransform(1717.15,32,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).wait(8));

	// size
	this.instance_10 = new lib.size_1920x80();

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,112.7);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		// const gotoPage = (event, {url}) => {
		//     /**
		//      * Go back page for portal.
		//      */
		//     window.open(url, '_self');
		// }
		//
		// this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		// this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage, false, false, {url: 'http://portal-terra-web.local'});
		    
		const gotoPage = () => {
		    /**
		     * Close page with extension plugin chrome.
		     */
			//chrome.runtime.sendMessage('maglcmgfenlbeehaeohfbkncflcafmko', {action: 'closeBrowser'});
		    /**
		     * Close page with window browser.
		     */
			window.close();
		}
		
		this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(207,219,179,0.698)").beginStroke().moveTo(-39.1,15.9).curveTo(-48.3,15.9,-48.3,7.9).lineTo(-48.3,-8).curveTo(-48.3,-15.9,-39.1,-15.9).lineTo(39.1,-15.9).curveTo(48.3,-15.9,48.3,-8).lineTo(48.3,7.9).curveTo(48.3,15.9,39.1,15.9).closePath();
	this.shape.setTransform(1617.175,1120.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// go_back
	this.btn_go_back = new lib.go_back();
	this.btn_go_back.name = "btn_go_back";
	this.btn_go_back.setTransform(1880,1000);
	this.btn_go_back.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.btn_go_back).wait(1));

	// button
	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1618.65,1040.05,0.8255,0.4688,0,0,0,0.8,0.1);
	this.btn_page08.visible = false;
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(768.8,1040.05,1.9192,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1772.35,1040.05,1.4136,0.4688,0,0,0,0.7,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1471.3,1040.05,1.3062,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1298.7,1040.05,1.2074,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(1058.35,1040.05,2.4148,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(548.6,1040.05,1.3398,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(397.25,1040.05,0.8648,0.4688,0,0,0,0.1,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page09},{t:this.btn_page04},{t:this.btn_page08}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(174.3,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker_title
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(388.45,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// logo
	this.occ_logo = new lib.logo();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(47.05,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background_shadow
	this.instance = new lib.title();
	this.instance.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// background
	this.instance_1 = new lib.background();
	this.instance_1.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_2 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,0,1924,1136.6), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, library_name);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1136.6);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#CCCC00",
	opacity: 0.00,
	manifest: [
		{src:"./images/CachedBmp_229.png?1750981075415", id:"CachedBmp_229"},
		{src:"./images/index_atlas_1.png?1750981075383", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
